<template>
  <v-container fluid>
    <v-row>
      <v-col class="d-block d-lg-none" cols="auto">
        <v-btn icon @click="navDrawer = !navDrawer">
          <v-icon> mdi-menu </v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <navigation-drawer
        class="d-block d-lg-none"
        :absolute="true"
        :temporary="true"
        :items="navBarCalculated"
        v-model="navDrawer"
      >
      </navigation-drawer>
      <v-col class="d-none d-lg-block" md="auto">
        <div>
          <div v-if="!isMe">
            <h3 class="mb-4 pl-2">{{ entity.name }} {{ entity.surname }}</h3>
          </div>
          <navigation-drawer :items="navBarCalculated" stateless :value="true">
          </navigation-drawer>
        </div>
      </v-col>
      <v-col>
        <router-view></router-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import NavigationDrawer from "@/components/navigation-drawer/NavigationDrawer";
import { navBarItemsAdmin, navBarItemsProfile } from "./tabs/navBarItems";
import { isMe } from "@/common/mapAuthGetter";
import RepositoryFactory from "@/repositories/RepositoryFactory";

const UserDataEntityRepository = RepositoryFactory.get(
  "UserDataEntityRepository"
);

export default {
  name: "AdminDetail",
  components: {
    NavigationDrawer,
  },
  data() {
    return {
      navDrawer: false,
      entity: {},
    };
  },
  computed: {
    navBarCalculated() {
      return this.$route.params.id ? navBarItemsAdmin : navBarItemsProfile;
    },
    isMe() {
      return isMe(this.entity.login);
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this._fetchData(this.$route.params.id);
    }
  },
  methods: {
    _fetchData(id) {
      return UserDataEntityRepository.getByUserId(id)
        .then((response) => {
          this.entity = response;
        })
        .catch(() => this.$log.debug("Error fetching Admins with ID " + id));
    },
  },
};
</script>
